"use client";

// MitID UX requirements: https://www.mitid.dk/en-gb/about-mitid/for-developers/
// Button: background #0060e6, white text, border-radius 4px, height 48px
// Font: IBM Plex Sans

import Link from "next/link";
import { usePathname } from "next/navigation";

interface MitidButtonProps {
  returnTo?: string;
}

export function MitidButton({ returnTo }: MitidButtonProps) {
  const pathname = usePathname();
  const href = `/verificer?return=${encodeURIComponent(returnTo ?? pathname)}`;

  return (
    <Link
      href={href}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        background: "#0060e6",
        color: "#ffffff",
        borderRadius: "4px",
        height: "48px",
        padding: "0 24px",
        fontSize: "15px",
        fontWeight: 500,
        fontFamily: "'IBM Plex Sans', sans-serif",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <img
        src="/mitid-logo.png"
        alt="MitID"
        style={{ filter: "brightness(0) invert(1)", height: "24px", width: "auto" }}
      />
      Verificér
    </Link>
  );
}
